import { type UseQueryResult, useQuery } from 'react-query';
import {
  VendorTermsAndConditionsSharedService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsListDto,
} from '../../services/wealthlane-customer-services';

const useGetVendorTermAndCondition = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  token?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsListDto[] | undefined,
  unknown
> => {
  const vendorTermAndCondition = useQuery(['getVendorTermAndCondition', token], async () => {
    if (token) {
      return await handleRequest(
        VendorTermsAndConditionsSharedService.getApiCustomerApiVendorTermsAndConditionsParticipantOnboarding(
          token
        )
      );
    }
  });

  return vendorTermAndCondition;
};

export default useGetVendorTermAndCondition;
